module.exports = __webpack_public_path__ + "static/media/7.1.1. REGISTRO-DE-ACTIVOS DE LA INFORMACION NOTARIA (1).df82f6f1.pdf";